// extracted by mini-css-extract-plugin
export default {"container":"donut_container__rH0xR","chartContainer":"donut_chartContainer__BDG5r","legendContainer":"donut_legendContainer__6IEKy"};